import { Spinner } from '@iwoca/orion';

import styles from './RouteSpinner.module.css';

const RouteSpinner = () => {
  return (
    <div className={styles.signupSpinnerContainer}>
      <Spinner className={styles.pageSpinner} />
    </div>
  );
};

export default RouteSpinner;
